import { colors, colorsBankee } from "themes/palette/colors"
import { getColorApp } from "utils/color"

export const dashboardTitleSx = {
  fontSize: "22px",
  lineHeight: "128%",
  letterSpacing: "-0.22px",
  fontWeight: 700,
}

export const sectionToggleChipSx = (isSelected: boolean) => ({
  height: "auto",
  p: "8px 16px",
  border: "none",
  borderRadius: "16px",
  bgcolor: isSelected ? "mockup.primary60" : "mockup.primary95",
  color: isSelected
    ? "mockup.neutral100"
    : getColorApp(colors.primary60, colorsBankee.primary30),
  "&:hover, &.MuiChip-clickable:hover": {
    bgcolor: isSelected ? "mockup.primary60" : "mockup.primary95",
  },
  "&.Mui-focusVisible": {
    bgcolor: isSelected ? "mockup.primary60" : "mockup.primary95",
    outline: "2px solid",
    outlineColor: "mockup.primary60",
    outlineOffset: "2px",
  },
  "& .MuiChip-label": {
    p: 0,
    fontSize: "14px",
    fontWeight: isSelected ? 500 : 700,
    lineHeight: "128%",
  },
})

// The class filter's text buttons (Apply, Cancel, Discard, Clear all), sized to the 24px chips.
export const classFilterButtonSx = {
  height: 24,
  minHeight: 0,
  minWidth: 0,
  py: 0,
  px: 1,
  borderRadius: "12px",
  typography: "body3",
  fontWeight: 700,
  textTransform: "none",
}
